<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <div style="display: flex;">
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form" style="margin-left: -14px;margin-right: -6px;margin-bottom: 15px; flex: 1;">
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("state")}}
                </div>
              </div>
              <div class="table-search-form-flex" style="max-width: 240px;">
                <div class="table-search-form-box">
                  <el-select v-model="searchForm.state" :placeholder="$I18n('state')">
                    <el-option :value="0" :label="$I18n('all')"></el-option>
                    <el-option :value="1" :label="$I18n('open')"></el-option>
                    <el-option :value="2" :label="$I18n('closed')"></el-option>
                  </el-select>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("type")}}
                </div>
              </div>
              <div class="table-search-form-flex" style="max-width: 240px;">
                <div class="table-search-form-box">
                  <el-select v-model="searchForm.type" :placeholder="$I18n('type')">
                    <el-option :value="0" :label="$I18n('all')"></el-option>
                    <el-option :value="1" :label="$I18n('topon')"></el-option>
                    <el-option :value="2" :label="$I18n('admob')"></el-option>
                    <el-option :value="3" :label="$I18n('goad')"></el-option>
                  </el-select>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("company")}}
                </div>
              </div>
              <div class="table-search-form-flex" style="max-width: 240px;">
                <div class="table-search-form-box">
                  <el-select v-model="searchForm.comp_path" :placeholder="$I18n('type')">
                    <el-option :value="''" :label="$I18n('all')"></el-option>
                    <el-option v-for="comp in companys" :key="comp.id" :value="comp.path" :label="comp.comp_name"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="display: flex;align-items: center;padding-bottom: 6px;">
              <!-- 按钮 {大屏幕模式} -->
              <div class="md-layout md-layout-item left-layout-item" :style="{'justify-content': 'flex-end','height':'36px'}">
                  <button class="left-icon md-info" @click="form_changeSearchData" style="margin-bottom: 0;">
                    <md-icon>search</md-icon>
                    {{$I18n("search")}}
                  </button>
                  <button class="left-icon md-info" @click="reset_serach" style="margin-bottom: 0;">
                    <md-icon>refresh</md-icon>
                    {{$I18n("reset")}}
                  </button>
                  <button class="left-icon md-info" @click="table_addItem" style="margin-bottom: 0;">
                    <md-icon>add</md-icon>
                    {{$I18n("add")}}
                  </button>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 分页 -->
    <div class="md-layout-item md-size-100" style="padding-top: 0;">
      <md-card style="margin: 0;">
        <div style="padding: 20px 20px 0;">
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="'ID'">
                {{item.id}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('name')">
                {{item.name}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('company')">
                {{item.comp_name}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('plat_acc_id')">
                {{item.ad_account_id}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('plat_acc_key')">
                {{item.ad_secret_key}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('state')">
                {{item.state_name}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('type')">
                {{item.type_name}}
              </md-table-cell>

              <md-table-cell :md-label="$I18n('update_date')">
                {{item.update_time}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">
                {{item.create_time}}
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click.stop="table_editItem(item)" class="md-just-icon md-round md-info" style="margin-right: 8px;">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click.stop="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
              <!-- 操作 -->
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
        </div>
        <table-page-v2 :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modal_title"
      :right = "!openModalType.includes('delete')"
      @submit= "modal_submit"
      @close = "closeModal"
    >
      <template slot="body">
        <!-- 确认信息 {只在删除主/子菜单的时候才展示该部分} -->
        <div v-if="openModalType.includes('delete')">
          {{$I18n("check_delete", $I18n("lang_i18n") === "zh" ?modalData.Form.name :modalData.Form.name)}}
        </div>
        <!-- 表单-修改/添加菜单表单 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
// import {Tooltip as ElTooltip} from 'element-ui';
import { timestampToString, FormClass/* nMonthsAgo, nDaysAgo,  */ } from "@/common/tools.js";
export default {
  components: {
    // ElTooltip,
  },
  data() {
    return {
      companys: [],
      searchForm : { // 查询表单用的数据
        state:0,
        type :0,
        comp_path: "",
      },
      searchData: {
        state:0,
        type :0,
        comp_path: "",
      }, // 检索范围

      tableInitData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      total    : 0,
      currentPage : 1,

      openModalType: "add",
      modal_title: "",
      modalData: new FormClass({
        name: "",
        comp_path: "",
        ad_account_id: "",
        ad_secret_key: "",
        type: 1,
        state: 1,
      },{
        name: "required",
        ad_account_id: "required",
        // ad_secret_key: "required",
      }),

      canReload: true, // 防止重复查询
    };
  },
  mounted : function() {
    this.$api.getCompanyList({})
      .then(this.$Then(res => {
        this.companys = res.data;
        this.modalData.SetInit(res.data[0].path, "comp_path");
      }))
      .catch(this.$Catch());
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    pageSize(){
      this.api_getPageData(1);
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    closeModal(){// 关闭表单时重新查询表格数据,以及重置弹窗内的校验结果
      this.api_getPageData();
    },
    table_addItem(){
      this.modal_title = this.$I18n("add");
      this.openModalType = "add"
      this.modalData.Reset();
      this.$refs.modal.open();
    },
    table_editItem(item){
      this.modal_title = this.$I18n("edit");
      this.openModalType = "edit"
      this.modalData.Update(item);
      this.$refs.modal.open();
    },
    table_deleteItem(item){
      this.modal_title = this.$I18n("delete");
      this.openModalType = "delete"
      this.modalData.Update(item);
      this.$refs.modal.open();
    },
    reset_serach(){
      this.searchForm = { // 查询表单用的数据
        state:0,
        type :0,
      }
    },
    form_changeSearchData(){
      this.searchData = {
        ...this.searchForm,
      }
      this.api_getPageData(1);
    },
    // 获取页面信息
    api_getPageData(newPage){
      // 防止重复查询
      if(!this.canReload){
        return
      }
      this.canReload = false;
      if(newPage){
        this.currentPage = newPage
      }

      // 获取角色
      this.$api.getAdAcc({ // api: /v2/user/admin/feedback/list
          ...this.searchData,
          page_size: this.pageSize,
          page_no  : newPage ?newPage :this.currentPage,
      })
        .then(this.$Then(res => {
          this.canReload = true;
          this.tableInitData = res.data;
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.canReload = true;
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    modal_submit () { // 弹窗-提交表单数据
      if (this.openModalType === "add") { // 提交 添加菜单
        this.modal_submitAdd();
      } else if (this.openModalType === "edit"){ // 提交 修改菜单
        this.modal_submitEdit();
      } else if(this.openModalType === "delete"){ // 提交 删除菜单
        this.modal_submitDel();
      }
    },
    modal_submitAdd () { // 弹窗-提交 添加菜单
      if (this.modalData.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.addAdAcc(this.modalData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("add_success"));
          this.$refs.modal.close()
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },
    modal_submitEdit () { // 弹窗-提交 修改菜单
      if (this.modalData.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      this.$api.editAdAcc(this.modalData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close()
        }))
        .catch(this.$Catch(this.$I18n("edit_fail")))
    },
    modal_submitDel (){ // 弹窗-提交 删除菜单
      this.$api.delAdAcc(this.modalData.Form)
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.$refs.modal.close()
        }))
        .catch(this.$Catch(this.$I18n("delete_fail")))
    },
  },
  computed: {
    tableData(){ // 表格数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          let state_name = this.$I18n("unknow");
          if(item.state == 1){
            state_name = this.$I18n("open");
          } else if(item.state == 2){
            state_name = this.$I18n("closed");
          }
          let type_name = this.$I18n("unknow");
          if(item.type == 1){
            type_name = this.$I18n("topon");
          } else if(item.type == 2){
            type_name = this.$I18n("admob");
          } else if(item.type == 3){
            type_name = this.$I18n("goad");
          }
          
          return {
            ...item,
            state_name,
            type_name,
            create_time: timestampToString(item.gmt_create * 1000),
            update_time: timestampToString(item.gmt_update * 1000),
          }
        });
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("company"),
          keys    : "comp_path",
          type    : "select",
          options : this.companys.map(i => {
            return {
              id  : i.path,
              name: i.comp_name,
            }
          }),
          required: true,
          check   : true,
        },{
          label   : this.$I18n("plat_acc_id"),
          keys    : "ad_account_id",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("plat_acc_key"),
          keys    : "ad_secret_key",
          type    : "input",
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {id: 1, name: this.$I18n("open")},
            {id: 2, name: this.$I18n("closed")},
          ],
        },{
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : [
            {id: 1, name: this.$I18n("topon")},
            {id: 2, name: this.$I18n("admob")},
            {id: 3, name: this.$I18n("goad")},
          ],
        },
      ]
    },
  },
}
</script>
<style lang="css" scoped>
button.left-icon /deep/ i{
  color: #FFFFFF !important;
}
button.left-icon{
  background: #00bcd4;
  border: none;
  color: #FFFFFF;
  border-radius: 4px;
  line-height: 36px;
  height: 36px;
  padding: 0 30px;
  cursor: pointer;
}
/*.left-icon /deep/ .md-ripple{
  padding: 4px 30px !important;
}*/
.table-image-box{
  margin: 0 -5px;
}
.table-image{
  max-height: 34px;
  width: auto;
  max-width: 34px;
  margin: 0 5px;
}
.table-operate{
  width: 80px;
}
.table-ceil{
  display: inline-block;
  line-height: 36px;
  max-width: 15vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .md-card .md-subhead{
  opacity: 1 !important;
}
.order-card-title-span{
  color: #A5A5A5;
  padding-right: 24px;
  font-size: 14px;
  font-family: Microsoft YaHei;
}
.order-info-body{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.order-info-body .md-layout-item>div{
  margin-bottom: 8px;
}
/deep/ .md-card-actions.md-alignment-right{
  border-top: 0 !important;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info{
  margin-bottom: 0px;
}
/deep/ .md-card-actions.md-alignment-right .md-button.md-info .md-ripple{
  padding: 12px 16px;
}
/deep/ .md-card-actions.md-alignment-right{
  padding-top: 0 !important;
}
.md-table-md-button{
  height: 37px;
}
.table-search-form-box /deep/ .md-date-form-item{
  padding-right: 0 !important;
}
.table-search-form-box /deep/ .el-date-editor .el-range-input{
  width: 44%;
}
.table-search-form-box.none-clean /deep/ .el-date-editor .el-range-input{
  width: 47%;
}
.table-search-form-box.none-clean{
  padding-right: 8px;
}
.table-search-form-box.none-clean /deep/ .el-input__icon.el-range__close-icon{
  display: none;
}
</style>
<style lang="scss" scoped>
  .md-form-label{
    color: #aaa;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    padding-top: 20px;
    text-align: left;
  }
  .md-chip{
    cursor:pointer;
    line-height: 24px;
    height: 24px;
    margin: 2px 3px !important;
  }
  .md-chip .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip:hover .md-ripple{
    padding: 0px 6px !important;
  }
  .md-chip.md-info{
    background: rgb(0, 188, 212) !important;
  }
  .md-chip.md-danger{
    background: #f44336 !important;
  }
  .md-info{
    margin-top : 0 !important;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .order-card{
    margin:8px 0;
  }
  .order-card .order-card-title span{
    margin-right : 10px;
  }

  .order-card .order-card-title-state {
    float : right;
    position : absolute;
    top : 0px;
    right : 40px;
    font-weight: 700;
  }
  .order-card .success {
    color : #4caf50;
  }
  .order-card .warning {
    color : #f44336;
  }
  .order-card .line {
    height : 1px;
    margin : 0 20px;
    background-color : rgb(238, 238, 238);
  }
  .order-card .foot-box {
    text-align : left;
    width : 100%;
  }
  .order-card .foot-box .foot-box-left {
    margin-left :16px;
  }
  .order-card .foot-box .foot-box-right {
    float : right;
    font-size: 14px;
    font-weight: 400;
    font-family: Microsoft YaHei;
    color: #A5A5A5;
  }
  .order-card .foot-box .foot-box-right div{
    margin-right : 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-right:8px;
    padding-left:8px;
  }
  .no-margin-layout-item {
    padding-left:0;
    padding-right: 0;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
  .left-btn {
    text-align:left;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  @media screen and ( max-width: 600px ){
    .md-card .md-subhead {
      margin-left: 0;
    }
    .order-card-title span{
      display:block;
    }
    .foot-box span, .foot-box div{
      width: 50%;
      margin-right: -16px !important;
      margin-left: 16px !important;
    }
    .order-card{
      padding: 16px 0;
    }
  }
</style>
